import { Component, inject, OnInit } from '@angular/core';
import { PlannerComponent } from "../../shared/planner/planner.component";
import { MapComponent } from "../../shared/map/map.component";
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CUSTOM_ROUTE_DESKTOP_MAP } from './config/constants';
import { CustomRouteDesktopViewStateService } from './services/custom-route-desktop-view-state.service';
import { CustomRouteDesktopViews } from './interfaces/custom-route-desktop.interface';
import { CustomRouteService } from '../../services/custom-route.service';

@Component({
  selector: 'app-custom-route-desktop',
  standalone: true,
  imports: [
    PlannerComponent,
    MapComponent,
],
  templateUrl: './custom-route-desktop.component.html',
  styleUrls: ['./custom-route-desktop.component.scss'],
})
export class CustomRouteDesktopComponent implements OnInit {
  private _customRouteDesktopViewStateService = inject(CustomRouteDesktopViewStateService);
  private _customRouteService = inject(CustomRouteService);
  private _sessionStorageService = inject(SessionStorageService);
  
  protected desktopViewState = this._customRouteDesktopViewStateService.desktopViewsState;
  protected isWelcomeViewShown = this._customRouteService.isWelcomeViewShown;
  protected noSaturedPoints = this._customRouteService.noSaturedPoints;
  
  public customRouteDesktopViews = CUSTOM_ROUTE_DESKTOP_MAP;

  ngOnInit(): void {      
    // Get the state view for desktop from session storage
    const desktopViewStateSessionStorage = this._sessionStorageService.getItem('customRouteDesktopViewsState') as CustomRouteDesktopViews;
    if (desktopViewStateSessionStorage) {
      this._customRouteDesktopViewStateService.desktopViewsState.set(desktopViewStateSessionStorage);
    }
    
    // Clear the custom route mobile views state from session storage
    const customRouteMobileViewsState = this._sessionStorageService.getItem('customRouteMobileViewsState');
    if (customRouteMobileViewsState) { 
      this._sessionStorageService.removeItem('customRouteMobileViewsState')
    }
  }
}
